export enum CommunityCategoryType {
  QNA = "QNA",
  FREE_QNA = "FREE_QNA",
  FREE_BOARD = "FREE_BOARD",
  NOTICE = "NOTICE"
}
